module.exports = __webpack_public_path__ + "static/img/1.f2c0a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/1.png
// module id = 2krw
// module chunks = 0